import { ordenTrabajoApi } from '../../utils/api';
import { getListDataAction } from '../../utils/DataAction';

export const getAll = getListDataAction({
  dataName: 'ORDEN_TRABAJO_ESTADO',
  api: ordenTrabajoApi,
  relUrl: 'getAllEstados',
});
